<template>
  <el-main
    v-loading="!chartData"
    element-loading-background="rgba(122, 122, 122, 0.05)"
    style="height:250px;"
  >
    <Doughnut
      v-if="chartData"
      class="loading"
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </el-main>
</template>

<script>
// vue-chartjs with vue2
import { Doughnut } from 'vue-chartjs/legacy'
// chartjs
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  ArcElement,
  CategoryScale
} from 'chart.js'
// ChartDataLabels -> 在甜甜圈上顯示數字
import ChartDataLabels from 'chartjs-plugin-datalabels'
import DoughnutCenterText from './DoughnutCenterText'

ChartJS.register(Title, Tooltip, ArcElement, CategoryScale)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    period: {
      type: String
    },
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 250
    },
    height: {
      type: Number,
      default: 250
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      // 在甜甜圈的圈圈上顯示數字
      // 在甜甜圈中間顯示文字
      default: () => [ChartDataLabels, DoughnutCenterText]
    },
    chartData: {
      type: Object
    }
  },
  data () {
    return {
      chartOptions: {
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.yLabel
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          // 2. 在甜甜圈上顯示數字改成顯示比例
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              const dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              const percentage = (value * 100 / sum).toFixed(1) + '%'
              // 比例前加上 label
              const label = ctx.chart.data.labels[ctx.dataIndex]
              return `${label}\n` + percentage
            },
            color: '#fff'
          }
        },
        // 在甜甜圈中間顯示文字
        elements: {
          center: {
            text: '本' + this.period,
            color: '#666', // Default is #000000
            fontStyle: 'Arial', // Default is Arial
            sidePadding: 100, // Default is 20 (as a percentage)
            minFontSize: 18, // Default is 20 (in px), set to false and text will not wrap.
            lineHeight: 25 // Default is 25 (in px), used for when text wraps
          }
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0;
}
</style>
